import { useLogin, usePrivy, useWallets } from '@privy-io/react-auth'
import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { Link } from 'common/Link'
import { Modal } from 'common/Modal'
import { ModalContentDialog } from 'common/Modal/ModalContentDialog'
import { ProgressScreens } from 'common/ProgressScreens'
import { useStore } from 'lib/store'
import { ComponentProps } from 'lib/theme'
import { observer } from 'mobx-react-lite'
import { Flex } from 'primitives/Flex'
import { Text } from 'primitives/Text'
import { useCallback, useEffect, useState } from 'react'
import { ModalTitle } from '../components/ModalTitle'

const SCREENS = {
  CONNECT: {
    level: 0,
    parent: 'CONNECT (new)',
    title: 'Connect'
  }
  // DISCONNECT: {
  //   level: 0,
  //   parent: 'DISCONNECT',
  //   title: 'Disconnect'
  // },
  // CONFIRM_WALLET: {
  //   level: 1,
  //   parent: 'CONNECT',
  //   title: 'Confirm wallet'
  // },
  // LOGIN: {
  //   level: 1,
  //   parent: 'CONNECT',
  //   title: 'Login'
  // },
  // LINK_WALLET: {
  //   level: 2,
  //   parent: 'LOGIN',
  //   title: 'Link wallet'
  // },
  // FORGOT_PASSWORD: {
  //   level: 2,
  //   parent: 'LOGIN',
  //   title: 'Forgot your password?'
  // },
  // CONFIRM_LINK: {
  //   level: 3,
  //   parent: 'LINK_WALLET',
  //   title: 'Confirm wallet'
  // },
  // ALREADY_LINKED: {
  //   level: 4,
  //   parent: 'CONFIRM_LINK',
  //   title: 'Unable to link wallet'
  // }
} as const

export type ConnectModalScreens = keyof typeof SCREENS
// @ts-ignore
const DISMISS_DISABLED_SCREENS: ConnectModalScreens[] = ['LINK_WALLET', 'CONFIRM_LINK']

type Props = ComponentProps<typeof Button>

export const ConnectModal = observer(({ css, ...props }: Props) => {
  const { connectWallet, user: privyUser, getAccessToken } = usePrivy()
  const { wallets } = useWallets()
  const store = useStore()
  const [isOpen, setIsOpen] = useState(false)
  const [activeScreen, setActiveScreen] = useState<ConnectModalScreens>('CONNECT')

  useEffect(() => {
    const authenticateUser = async () => {
      const accessToken = await getAccessToken()

      if (accessToken && privyUser) {
        await store.user.authenticateWithPrivy(accessToken)
        await store.user.setPrivyUser(privyUser)
      }
    }

    if (privyUser) authenticateUser()
  }, [privyUser])

  useEffect(() => {
    store.wallets.setWallets(wallets)
  }, [wallets])

  // TODO: Use this area to eagerly resolve the users authenticated status

  // https://docs.privy.io/guide/react/callbacks#uselogin
  const { login } = useLogin({
    onComplete: (user, isNewUser, wasAlreadyAuthenticated, loginMethod) => {
      console.log('login.onComplete()')
      console.log(user, isNewUser, wasAlreadyAuthenticated, loginMethod)
      // Any logic you'd like to execute if the user is/becomes authenticated while this
      // component is mounted
    },
    onError: (error) => {
      console.log('onError()')
      console.log(error)
      // Any logic you'd like to execute after a user exits the login flow or there is an error
    }
  })

  // const getTitle = useCallback(() => {
  //   switch (activeScreen) {
  //     default: {
  //       return SCREENS[activeScreen].title
  //     }
  //   }
  // }, [activeScreen])

  // const onBack = useCallback(() => {
  //   // Link wallet is a forced action, user must do this to continue.
  //   ui.setConnectModalScreen(SCREENS[activeScreen].parent)
  //   setDefaultPrivacyAge()
  // }, [activeScreen, ui])

  const getActiveScreenIndex = useCallback(() => SCREENS[activeScreen].level, [activeScreen])

  // const handleLogin = () => {
  //   ui.closeConnectModal()
  // }

  // const handleReset = () => {
  //   ui.setConnectModalScreen('FORGOT_PASSWORD')
  // }

  // const handleCloseModal = () => {
  //   setDefaultPrivacyAge()
  //   if (!DISMISS_DISABLED_SCREENS.includes(activeScreen)) ui.closeConnectModal()
  // }

  // const handleDisconnect = () => {
  //   user.logout()
  //   handleCloseModal()
  //   analytics.track(NSFW_EVENT.WALLET_LOGOUT)
  // }

  return (
    <>
      {/* CTA */}
      <Button
        onClick={() => {
          login()
          // setIsOpen(true)
        }}
        theme="primary"
        css={{
          borderRadius: 8,
          minWidth: 'min-content',
          ...css
        }}
        {...props}
      >
        Connect
      </Button>

      {/* Modal — FIXME: This should be a portal!! */}
      <Modal
        isOpen={isOpen}
        onBackgroundClick={() => {
          setIsOpen(false)
        }}
        animation="fadeIn"
        backdrop="blurred"
        style={{ zIndex: 9 }}
      >
        <ModalContentDialog>
          <ModalTitle>Some title</ModalTitle>
          <ProgressScreens activeIndex={getActiveScreenIndex()} minHeight="auto">
            {/* Level 0 - connect */}
            <Flex column fullHeight>
              {activeScreen === 'CONNECT' && (
                <Flex column full>
                  {!privyUser && (
                    <Text
                      type="caption2"
                      subText
                      center
                      css={{ margin: '16px 0 24px', fontSize: 14 }}
                    >
                      Please connect your wallet in order to continue.
                    </Text>
                  )}
                  <Text
                    subText
                    css={{
                      marginBottom: 20,
                      alignSelf: 'center',
                      fontSize: 14,
                      fontWeight: 500
                    }}
                  >
                    New to Ethereum wallets?{' '}
                    <Link
                      href="https://ethereum.org/en/wallets"
                      nounderline
                      css={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: '$voilet100',
                        '&:hover': {
                          lineHeight: '10px',
                          borderBottom: '1px solid $voilet100'
                        }
                      }}
                      target="_blank"
                      rel="noopener"
                    >
                      Learn more
                      <Icon icon="ExternalLink" css={{ marginLeft: '2px' }} />
                    </Link>
                  </Text>
                </Flex>
              )}
              {/* {activeScreen === 'DISCONNECT' && (
                <Flex column fullHeight>
                  <ConfirmPopupDialogDescription css={{ padding: '24px 0 8px' }}>
                    Are you sure you want to disconnect your wallet and logout?
                  </ConfirmPopupDialogDescription>
                  <ConfirmPopupDialogActions>
                    <ConfirmPopupDialogYesButton onClick={handleDisconnect} />
                    <ConfirmPopupDialogNoButton onClick={handleCloseModal} />
                  </ConfirmPopupDialogActions>
                </Flex>
              )} */}
            </Flex>

            {/* Level 1 - confirm wallet | login */}
          </ProgressScreens>
        </ModalContentDialog>
      </Modal>
    </>
  )
})
